var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-upload',{staticClass:"avatar-uploader",attrs:{"action":"https://","http-request":function (file) {
            _vm.uploadFile(file);
        },"show-file-list":false,"before-upload":_vm.beforeAvatarUpload,"accept":"image/*"}},[(_vm.imageUrl)?_c('img',{staticClass:"avatar",attrs:{"src":_vm.imageUrl}}):_c('i',{staticClass:"el-icon-plus avatar-uploader-icon"})])}
var staticRenderFns = []

export { render, staticRenderFns }